import React from "react";
import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { ChoirSection } from "./components/ChoirSection";
import { ChoirTestCTA } from "./components/ChoirTestCTA";
import { ServicesSection } from "./components/ServicesSection";
import { PhotoGallery } from "./components/PhotoGallery";
import { AlbumPromotion } from "./components/AlbumPromotion";
import { BookSales } from "./components/BookSales";
import { ChoirTest } from "./components/ChoirTest";
import { BusOfBlessings } from "./components/BusOfBlessings";
import { Footer } from "./components/Footer";
import { LiveChat } from "./components/LiveChat";
import { AdminDashboard } from "./components/AdminDashboard";
import { VisitorCounter } from "./components/VisitorCounter";

const Home = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <HeroSection />
      <AboutSection />
      <ChoirSection />
      <ChoirTestCTA />
      <ServicesSection />
      <PhotoGallery />
      <AlbumPromotion />
      <BookSales />
      <BusOfBlessings />
      <Footer />
      <LiveChat />
      <VisitorCounter />
    </div>
  );
};

const AssessmentPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <ChoirTest />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/assessment" element={<AssessmentPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;